import React from 'react'

export default function Notification() {
  return (
    <>
    
      <div className="container">
      <h1>Notification</h1>
      <div className="row">
        <div className="col-sm-12">
        <div className="card" style="width: 18rem;">
  <img src="..." className="card-img-top" alt="..."/>
  <div className="card-body" style={{background:"black"}}>
    <h5 className="card-title">Card title</h5>
    <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
    <a href="#" className="btn btn-primary">Go somewhere</a>
  </div>
</div>
        </div>
      </div>
      </div>
   
    </>
  )
}
